<mat-checkbox [id]="componentId+'_checkbox'"
	[aria-label]="ariaLabel ? ariaLabel : label"
	[name]="componentId+'_checkbox'"
	[value]="value"
	[checked]="checked"
	[disabled]="disabled"
	[indeterminate]="indeterminate"
	(keydown.enter)="onEnterKeydown()"
	(change)="onChange($event)">
	<label *ngIf="hasChild; else elseBlock" [id]="componentId+'_checkbox-label'" [for]="componentId+'_checkbox-input'">
		<ng-content></ng-content>
	</label>
	<ng-template #elseBlock>
		<label [id]="componentId+'_checkbox-label'" [for]="componentId+'_checkbox-input'">
			{{ label }}
		</label>
	</ng-template>
</mat-checkbox>
